import { Link, useRouterState } from '@tanstack/react-router';
import { cn } from '@siliconx/shared/ui/utils';

const TABS = [
  { to: '/environmental', label: 'Overview' },
  { to: '/environmental/fleet-detail', label: 'Fleet detail' },
  { to: '/environmental/reports', label: 'Reports' },
] as const;

/**
 * SIL-472 — Overview | Fleet detail | Reports. Overview (SIL-472) and
 * Fleet detail (SIL-476) are live. Reports (SIL-477) still renders an "In
 * development" placeholder (a real route, still in the tab bar, so the IA
 * reads complete even though the content isn't yet).
 *
 * SIL-576 (I2-D4): Circularity (SIL-473) was promoted out of this tab bar
 * to its own nav entry ("Circularity Outcomes", Intelligence › Portfolio
 * Intelligence), following the SIL-542 ESG Reports precedent. Its URL
 * (/environmental/circularity) is unchanged — only nav placement moved.
 *
 * SIL-612: `activeProps` is not used here — TanStack Router *concatenates*
 * `className` and `activeProps.className` rather than merging them, so
 * conflicting utilities (e.g. `border-transparent` vs `border-emerald-600`)
 * both land in the DOM class list and Tailwind resolves by stylesheet
 * order, not class-attribute order — the active state never won. Active
 * state is instead derived from the router pathname and the full class
 * string is merged with `cn()` (twMerge-backed, last-one-wins) so only one
 * of each conflicting pair survives.
 */
export function EnvironmentalTabBar() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <div className="flex gap-1 border-b border-zinc-200 text-sm font-semibold">
      {TABS.map((tab) => {
        const isActive = pathname === tab.to;
        return (
          <Link
            key={tab.to}
            to={tab.to}
            activeOptions={{ exact: true }}
            className={cn(
              '-mb-px border-b-2 px-3.5 py-2 hover:text-zinc-900',
              isActive ? 'border-emerald-600 text-emerald-700' : 'border-transparent text-zinc-500',
            )}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
}
